import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["FontLoaderWrapper"] */ "/app/components/font-loader-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/components/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceWorkerRegister"] */ "/app/components/service-worker-register.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SqliteLoader"] */ "/app/components/sqlite-loader.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
